import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../router/all_routes";
import CollapseHeader from "../../core/common/collapse-header/collapse-header";
import { DatePicker, TimePicker, Select } from "antd";
import dayjs, { Dayjs } from "dayjs";
import Table from "../../core/common/dataTable/index";
import useUserData from "../../custom_hooks/useUserData";
import axiosInstance from "../../API/axiosConfig";
import webserviceUrl, { BASE_URL } from "../../API/webserviceUrl";
import FormMask from "../uiInterface/forms/formelements/form-mask";
import { toast } from "react-toastify";
import Loading from "../loading/Loading";
import { McitiImg } from "../../utils/iconLogo";
import LoadingGreen from "../loading/LoadingGreen";
import axios from "axios";
import moment from "moment";

const AddAttendance = () => {
  const { employee_id, school_code, course } = useUserData();
  const [units, setUnits] = useState([]);
  const [formData, setFormData] = useState({
    school_code: school_code,
    acdmc_course_id: "",
    date: null,
    day: "",
  });
  // const dayOptions = [
  //   { value: "Monday", label: "Monday" },
  //   { value: "Tuesday", label: "Tuesday" },
  //   { value: "Wednesday", label: "Wednesday" },
  //   { value: "Thursday", label: "Thursday" },
  //   { value: "Friday", label: "Friday" },
  //   { value: "Saturday", label: "Saturday" },
  //   { value: "Sunday", label: "Sunday" },
  // ];
  // console(formData, "attendence formdata");
  const [students, setStudents] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [resError, setResError] = useState({});
  const [loading, setLoading] = useState(false);

  // Cohorts (batches) come from the get_batches API
  const [cohortOptions, setCohortOptions] = useState<any[]>([]);
  const [selectedCohort, setSelectedCohort] = useState<string>("");
  const [cohort, setcohort] = useState<any>({});
  const [cohortLoading, setCohortLoading] = useState(false);

  console.log(cohortOptions);

  // Fetch batches and use them as the cohort dropdown options
  const getCohorts = async () => {
    if (!school_code) return; // safety check
    try {
      setCohortLoading(true);
      const resp = await axiosInstance.post(webserviceUrl.get_batches, {
        employee_id,
        school_code,
      });

      const batchData = resp?.data?.data || [];
      setCohortOptions(batchData);
    } catch (error) {
      console.error("Error fetching cohorts:", error);
    } finally {
      setCohortLoading(false);
    }
  };

  useEffect(() => {
    getCohorts();
  }, [school_code]);

  useEffect(() => {
    if (course && Object.keys(course).length > 0) {
      setFormData((prevFormData) => ({
        ...prevFormData,
        acdmc_course_id: course.acdmc_course_id ?? "",
      }));
    }
  }, [course]);

  //GET STUDENTS ATtendence

  const getAttendence = async (e: any) => {
    e.preventDefault();
    try {
      setLoading(true);
      setResError({});
      const resp = await axiosInstance.post(webserviceUrl.view_attendence, {
        ...formData,
        day: formData.day,
        acdmc_course_id: cohort?.acdmc_course_id,
        // cohort: {
        //   acdmc_course_id: cohort?.acdmc_course_id,
        //   day: "Monday",
        // }, // send selected cohort along with the request
      });
      console.log(resp);
      if (resp?.data?.success) {
        const unitData = resp?.data?.data || [];
        //@ts-ignore
        const [day, month, year] = formData?.date?.split("-") || [];
        // Add 'key' field to each item (React uses this)
        const processed = unitData.map((item: any, index: number) => ({
          ...item,
          key: index + 1, // Or use item.lesson_plan_id if it's guaranteed unique,
          day: day,
          month: month,
          year: year,
        }));
        setStudents(processed || []); // Uncomment & adjust based on actual API response
      } else {
        setResError(resp?.data?.message);
      }
    } catch (error) {
      console.error("Error fetching attendance:", error);
    } finally {
      setTimeout(() => setLoading(false), 500);
    }
  };

  // useEffect(()=>{getAttendence()},[])
  const columns = [
    {
      title: "S.No.",
      dataIndex: "Sno",
      render: (text: string, record: any, index: number) => <p>{index + 1}</p>,
    },
    { title: "Name", dataIndex: "student_name" },
    { title: "Admission No", dataIndex: "adm_no" },
    {
      title: "Date",
      render: (record: any) => {
        const { day, month, year } = record;

        if (day && month && year) {
          return (
            <div>
              {`${String(day).padStart(2, "0")}-${String(month).padStart(2, "0")}-${year}`}
            </div>
          );
        } else {
          return <div>{formData?.date}</div>; // Or "N/A", if date fields are null
        }
      },
    },

    { title: "Status", dataIndex: "attendance" },
    {
      title: "Attendance Status",
      dataIndex: "attendance", // you can bind this to existing attendance
      render: (value: string, record: any, index: number) => (
        <select
          value={value}
          onChange={(e) =>
            handleChangeStatus(e.target.value, record.student_id)
          }
          className="form-select"
          style={{
            width: "120px",
            padding: "4px 8px",
            borderRadius: "4px",
            border: "1px solid #ccc",
            backgroundColor: "#fff",
          }}
        >
          <option value="Present">Present</option>
          <option value="Absent">Absent</option>
          {/* <option value="Urgency">Urgency</option> */}
        </select>
      ),
    },
  ];

  const handleChangeStatus = (value: string, studentId: string | number) => {
    // console("Changed to:", value, "for student ID:", studentId);
    // You can update the state here if you're maintaining a list of students
    //@ts-ignore
    const [day, month, year] = formData?.date?.split("-") || [];

    setStudents((prev: any) =>
      prev.map((student: any) =>
        student.student_id === studentId
          ? {
              ...student,
              attendance: value,
              day: day,
              month: month,
              year: year,
            }
          : student,
      ),
    );
  };
  //// console(students);

  const saveAttendence = async (e: React.FormEvent) => {
    setIsSubmitting(true);
    try {
      e.preventDefault();
      //// console("updated Atendence............", students);

      const resp = await axiosInstance.post(webserviceUrl.mark_attendence, {
        users: students,
        school_code,
      });
      // console(resp);

      if (resp?.data?.success) {
        toast.success(resp?.data?.message);
        setIsSubmitting(false);
      } else {
        toast.error(resp?.data?.message);
      }
    } catch (error: any) {
      console.error(error);
      toast.error(error?.response?.data?.message || "");
    } finally {
      setIsSubmitting(false);
    }
  };

  const [lessonPlanDays, setLessonPlanDays] = useState<[]>([]);
  const token = localStorage.getItem("token");

  useEffect(() => {
    const fetchLessonPlanDays = async () => {
      try {
        const res = await axios.post(
          `${BASE_URL}/getLessonPlanDays`,
          {
            class_name: "ALL",
            section: "A",
            level: "FACULTY",
            combination_code: "UBTE_FDP4",
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );
        if (res.data?.success) {
          const days = (res.data.data || []).map((item: any, index: number) => {
            return {
              label: `Day ${index + 1}`,
              value: item.day,
            };
          }); // drop the { day: null } placeholder entry
          setLessonPlanDays(days);
          // if (days.length > 0) {
          //   setActiveProgramDay(days[0]);
          // }
        }
      } catch (err) {
        console.error("Failed to fetch lesson plan days", err);
      }
    };

    fetchLessonPlanDays();
  }, []);

  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div>
            <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
              <div className="my-auto mb-2">
                <h2 className="mb-1">Show Attendance</h2>
                <nav>
                  <ol className="breadcrumb mb-0">
                    <li className="breadcrumb-item">
                      <Link to={all_routes.adminDashboard}>
                        <i className="ti ti-smart-home" />
                      </Link>
                    </li>
                    <li className="breadcrumb-item">Teacher</li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Show Attendance
                    </li>
                  </ol>
                </nav>
              </div>
              <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
                <div className="ms-2 head-icons">
                  <CollapseHeader />
                </div>
              </div>
            </div>
            <div className="mb-2">
              {/*
                Fixed positioning bug: the toggle button's width/content used
                to change (disabled "Loading cohorts..." -> enabled cohort
                name), so Popper measured the wrong size on the very first
                open. Giving the button a stable min-width, and rendering a
                fixed placeholder label instead of shifting text, keeps the
                measurement consistent from the first open onward. The old
                marginLeft/transform hack has been removed — it's no longer
                needed and was invalid CSS besides.
              */}
            </div>
          </div>
          <div className="card">
            <div className="card-body p-3">
              <form onSubmit={getAttendence}>
                <div className="row">
                  <div className="col-md-4 mb-3 mt-2 d-flex justify-center gap-4">
                    <div className="dropdown" style={{ marginTop: "-10px" }}>
                      <button
                        type="button"
                        className="btn btn-outline-light bg-white border d-inline-flex align-items-center"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                        disabled={cohortLoading || cohortOptions.length === 0}
                        style={{
                          minWidth: "220px",
                          justifyContent: "space-between",
                        }}
                      >
                        <div className="d-flex align-items-center">
                          <i className="ti ti-users me-2 text-primary" />
                          <span className="me-1 text-truncate">
                            {cohortLoading
                              ? "Loading cohorts..."
                              : selectedCohort || "Select Course"}
                          </span>
                        </div>
                        <i className="ti ti-chevron-down ms-1" />
                      </button>
                      <ul
                        className="dropdown-menu dropdown-menu-end p-2"
                        style={{ minWidth: "220px" }}
                      >
                        {cohortOptions.map((cohort: any, index: number) => (
                          <li key={cohort?.course_name ?? index}>
                            <button
                              type="button"
                              className={`dropdown-item rounded d-flex align-items-center justify-content-between${
                                cohort?.course_name === selectedCohort
                                  ? " active"
                                  : ""
                              }`}
                              onClick={() => {
                                setcohort(cohort);
                                setSelectedCohort(cohort?.course_name);
                              }}
                            >
                              {cohort?.course_name}
                              {cohort?.course_name === selectedCohort && (
                                <i className="ti ti-check" />
                              )}
                            </button>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                  <div className="col-md-4 mb-3 d-flex justify-center gap-4">
                    <label className=" mt-2 ">
                      <strong>Day</strong>
                    </label>
                    <div
                      style={{
                        width: "20px",
                        minWidth: "200px",
                        flexShrink: 0,
                      }}
                    >
                      <Select
                        value={formData.day || undefined}
                        onChange={(value) => {
                          // console(formattedDate);

                          setFormData((prev: any) => ({
                            ...prev,
                            day: value,
                            date: moment(value).format("DD-MM-YYYY"),
                          }));
                        }}
                        options={lessonPlanDays}
                        placeholder="Select day"
                        style={{ width: "100%", height: "100%" }}
                        showSearch
                        allowClear
                      />
                    </div>
                  </div>
                  <div
                    className="col-md-4 mb-3 d-flex justify-center gap-4"
                    aria-disabled
                  >
                    <label className=" mt-2 ">
                      <strong>Date</strong>
                    </label>
                    <label className="form-control">
                      <h6 style={{ color: "grey" }}>
                        {formData.day
                          ? moment(formData.day).format("DD-MM-YYYY")
                          : "Select Day"}
                      </h6>
                    </label>

                    {/* <DatePicker
                      value={
                        formData.date
                          ? dayjs(formData.date, "DD-MM-YYYY")
                          : null
                      }
                      onChange={(date) => {
                        const formattedDate = date
                          ? date.format("DD-MM-YYYY")
                          : "";
                        // console(formattedDate);
                        setFormData((prev: any) => ({
                          ...prev,
                          date: formattedDate,
                        }));
                      }}
                      format="DD-MM-YYYY"
                      className="form-control"
                      placeholder="Select date"
                    /> */}
                  </div>
                </div>

                {selectedCohort && formData.day && (
                  <button type="submit" className="btn btn-primary">
                    Show Attendance
                  </button>
                )}
              </form>
            </div>
          </div>

          {students?.length > 0 && (
            <div className="row">
              <div className="card pb-4">
                <div className="card-body p-3">
                  <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                    <h5>Attendance List</h5>
                    <div>
                      <button
                        className="btn btn-primary border-0"
                        type="button"
                        disabled={isSubmitting}
                        onClick={saveAttendence}
                        style={{ backgroundColor: `green` }}
                      >
                        {isSubmitting ? (
                          <>
                            <span
                              className="spinner-border spinner-border-sm  me-2"
                              role="status"
                              aria-hidden="true"
                            ></span>
                            Saving...
                          </>
                        ) : (
                          <>Save Attendence</>
                        )}
                      </button>
                    </div>
                  </div>
                </div>
                {loading ? (
                  <LoadingGreen size="40" paddingTop="10px" />
                ) : Object.entries(resError)?.length > 0 ? (
                  <p>-- No data found --</p>
                ) : (
                  <Table
                    dataSource={students}
                    columns={columns}
                    Selection={false}
                    attendance={true}
                  />
                )}
                <div>
                  <button
                    className="btn btn-primary border-0"
                    type="button"
                    disabled={isSubmitting}
                    onClick={saveAttendence}
                    style={{ backgroundColor: `green` }}
                  >
                    {isSubmitting ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm  me-2"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        Saving...
                      </>
                    ) : (
                      <>Save Attendence</>
                    )}
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      {/* /Page Wrapper */}
    </>
  );
};

export default AddAttendance;
